import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TransactionInvoiceService } from 'src/app/pages/transaction/services/transaction-invoice.service';
import { TransactionProfileService } from 'src/app/pages/transaction/services/transaction-profile.service';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { BaseManagement } from '../../services/base-management';
import { CostFormService } from '../../services/cost-form.service';
import { MultiLanguageService } from '../../services/multi-language.service';
import { ProcessService } from '../../services/process.service';
import { TransationReceiptService } from './transaction-receipt.service';
import { UserProcessProfileService } from '../../services/user-process-profile.service';

@Component({
  selector: 'prgov-transaction-receipt-modal',
  templateUrl: './transaction-receipt-modal.component.html',
  styleUrls: ['./transaction-receipt-modal.component.scss']
})
export class TransactionReceiptModalComponent extends BaseManagement
  implements OnInit {

  id: any;
  authorizationNumber: any;
  processId: any;
  processType: any;
  category: any;
  profile: any = {};
  dynamicCosts: any;
  initialPaymentDetails: any;
  toggleInitialPayment = false;

  cartReceiptList: any[] = [];
  showCartReceipt = false;
  subtotalCart: number;
  feeAmountCart: number;
  totalCart: number;
  belongToCart: any;
  tooltipTxt: string;

  infractionDetail: any[] = [];
  marbeteCost: any;
  initialPayment: any;

  showInitialPaymentAmount = false;

  radiationMachineCost: any;
  additionalCost: any = 0; // Para almacenar el AdditionalCost del invoice
  radiationMachineCount: number = 0; // Número de máquinas adicionales
  radiationMachineIndividualCost: number = 5; // Costo por máquina individual

  constructor(
    protected translate: TranslateService,
    public transationReceiptService: TransationReceiptService,
    public transactionInvoiceService: TransactionInvoiceService,
    public transactionService: TransactionService,
    public route: ActivatedRoute,
    public router: Router,
    public processService: ProcessService,
    public multiLanguageService: MultiLanguageService,
    public transactionProfileService: TransactionProfileService,
    public userProcessProfileService: UserProcessProfileService,
    public costFormService: CostFormService,
    public dialogRef: MatDialogRef<TransactionReceiptModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    // Data del modal
    this.id = data.Id;
  }

  ngOnInit() {
    this.refreshLanguage();

    this.startSaving('getting');
    this.transationReceiptService
      .getInvoiceById(this.id)
      .then((invoice: any) => {
        console.log('INVOICE', invoice);
        this.authorizationNumber = invoice[0].AuthorizationNumber;
        this.belongToCart = invoice[0].BelongToShoppingCart;

        // Capturar el AdditionalCost del invoice si existe
        this.additionalCost = invoice[0].AdditionalCost || 0;

        // Calcular el desglose de máquinas de radiación
        if (this.additionalCost > 0) {
          this.radiationMachineCount = Math.floor(this.additionalCost / this.radiationMachineIndividualCost);
        }

        this.transationReceiptService.getInitialPaymentDetails(this.id).then((data: any) => {
          this.initialPaymentDetails = data;
          this.initialPayment = this.initialPaymentDetails[0].InitialPaymentAmount;

          this.toggleInitialPayment = false;
          if (this.initialPaymentDetails.length > 0) {
            if (this.initialPaymentDetails[0].RequiresInitialPayment === true) {
              this.toggleInitialPayment = this.initialPaymentDetails[0].RequiresInitialPayment;
            }
          }
        });
        this.processId = invoice[0].UserProcessId;

        this.showInitialPaymentAmount = invoice[0].InvoiceHasCosts == 1 ? false : true;
        // this.getBoatFines();

        this.userProcessProfileService
          .getUserProcessProfiles(this.processId)
          .then((data: any) => {
            this.profile = data.Data.profile[0];
            this.stopSaving();
          });

        this.transactionService.getById(this.processId).then((process: any) => {
          this.processType = process;
        });
      });

      this.translate.get(['transactionInvoice.tooltipText'])
      .subscribe((translations: any) => this.tooltipTxt = translations['transactionInvoice.tooltipText']);
  }

  hasRadiationMachineCost(): boolean {
    return this.additionalCost > 0 && this.radiationMachineCount > 0;
  }

  backToTransaction() {
    this.router.navigate([`/transactions/edit/${this.transactionService.itemToEdit.Id}`]);
  }

  gotoUrl(id) {
    let url = 'transactions';

    if (id) {
      url = url + '/edit/' + id;
    }

    this.router.navigate([url]);
  }

  tryGoBack() {
    const processId = this.transationReceiptService.workingInvoice.UserProcessId;

    this.transactionService.visibleModule = 'invoice';

    this.transactionService.isReturning = true;

    this.router.navigate(['transactions/edit/' + processId]);
  }

  do() {
    this.translate.use('es');
  }



  // getBoatFines() {
  //   this.boatService.getFinesPayed(this.processId)
  //     .then(
  //       (data: any) => {
  //         if (data.Data) {
  //           this.marbeteCost = data.Data[0].MarbeteCost;
  //           data.Data.forEach(element => {
  //             this.infractionDetail.push(JSON.parse(element.ExternalData));
  //           });
  //         }
  //       }
  //     );
  // }
}
